import React from 'react'
import { Link, useHistory } from "react-router-dom"
import {
  Row,
  Col,
  Form,
  Input,
  Button,
  Select,
  // Checkbox
} from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { useAuth } from '../../contexts/AuthContext'
import { useStore } from "../../contexts/FireStoreContext"
import { filterOption } from "../../utils/helpers"
import countries from "../../data/countries"

const { Option } = Select

const Signup = () => {
  const { signup } = useAuth()
  const { roles } = useStore()
  console.log(roles)
  const history = useHistory()

  const onFinish = (values) => {
    let profile = {
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      role: values.role,
      iso2: values.iso2,
      status: "p"
    }
    signup(values.email, values.password, profile)
      .then(user => {
        history.push("/auth/login")
      })
    // console.log('Success:', values)
  }

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Row justify="center">
      <Col span={24} lg={{ span: 7 }}>
        <div className="form-container">
          <div className="form-header">
            <h1>Sign Up</h1>
            <p>Create your account</p>
          </div>
          <Form
            name="signup"
            // className="login-form"
            initialValues={{ role: "agent" }}
            size="large"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              name="firstName"
              rules={[
                {
                  required: true, message: 'First Name is required!'
                }
              ]}
            >
              <Input
                placeholder="First Name"
              />
            </Form.Item>
            <Form.Item
              name="lastName"
              rules={[
                {
                  required: true, message: 'Last Name is required!'
                }
              ]}
            >
              <Input
                placeholder="Last Name"
              />
            </Form.Item>
            <Form.Item
              name="email"
              rules={[
                {
                  required: true, message: 'E-mail is required!'
                },
                {
                  type: 'email', message: 'Please enter valid E-mail!',
                }
              ]}
            >
              <Input
                prefix={<UserOutlined />}
                placeholder="Email"
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Password is reuired!' }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="Password"
              />
            </Form.Item>
            <Form.Item
              name="confirm"
              // label="Confirm Password"
              dependencies={['password']}
              // hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password!',
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve()
                    }
                    return Promise.reject(new Error('Password and Confirm passwords does not match!'))
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                type="password"
                placeholder="Confirm Password"
              />
            </Form.Item>
            <Form.Item
              name="role"
              rules={[
                {
                  required: true, message: 'Role is required!'
                }
              ]}
            >
              <Select
                placeholder="Select Role"
              >
                {roles.map(role => (
                  <Option value={role.value} key={role.value}>{role.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              name="iso2"
              rules={[
                {
                  required: true, message: 'Country is required!'
                }
              ]}
            >
              <Select
                showSearch
                placeholder="Select Country"
                optionFilterProp="children"
                filterOption={filterOption}
                >
                {countries.map(country => (
                  <Option value={country.iso2} key={country.iso2}>{country.name}</Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item className="mt-2">
              <Button type="primary" htmlType="submit" size="large" className="px-4">
                Sign Up
              </Button>
              <span className="form-link-right ant-btn-lg">
                Have account? <Link to="/auth/login">Log In</Link>
              </span>
            </Form.Item>
          </Form>
        </div>
      </Col>
    </Row>
  )
}

export default Signup
